"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceStoreAppOrder = void 0;
exports.workspaceStoreAppOrder = function (axios) {
    return {
        getStoreAppsOrdersOrderNo: function (request) {
            var orderNo = request.pathParams.orderNo;
            return axios.get("/apps/orders/" + orderNo);
        },
        postStoreAppsOrdersOrderNoSubscription: function (request) {
            var orderNo = request.pathParams.orderNo;
            return axios.post("/apps/orders/" + orderNo + "/subscription");
        },
        postStoreAppsOrdersOrderNoSubscriptionTrial: function (request) {
            var orderNo = request.pathParams.orderNo;
            return axios.post("/apps/orders/" + orderNo + "/subscription/trial");
        }
    };
};
